/*
 * aura-page-aside.js: the content page sidebar (sections/main-page.liquid), 1024px and up.
 * Fills the best sellers with the first cards of sections/mega-popular.liquid (best-selling colors, as the
 * header's mega menu), fetched once the sidebar shows. If the request fails or has no cards, the block goes.
 * Keeps --aside-h at the sidebar's height, so a sidebar taller than the screen scrolls until its bottom
 * shows and then sticks (section-pages.css).
 */
(() => {
  const track = (n, p) => window.aura && window.aura.track(n, p);
  const desktop = window.matchMedia('(min-width: 1024px)');

  class AuraPageAside extends HTMLElement {
    connectedCallback() {
      if (this.sizer) return;
      this.sizer = new ResizeObserver(() => this.style.setProperty('--aside-h', `${this.offsetHeight}px`));
      this.sizer.observe(this);
      this.addEventListener('click', (e) => {
        const target = e.target.closest('a, button');
        if (!target) return;
        const card = target.closest('.card');
        track('aura_page_aside_clicked', card ? { item: card.dataset.handle, kind: 'product' } : { item: target.dataset.item, kind: 'shortcut' });
      });
      this.onMedia = () => { if (desktop.matches) this.load(); };
      desktop.addEventListener('change', this.onMedia);
      this.onMedia();
    }

    disconnectedCallback() {
      this.sizer?.disconnect();
      this.sizer = null;
      desktop.removeEventListener('change', this.onMedia);
    }

    load() {
      const grid = this.querySelector('[data-popular-url]');
      if (!grid || grid.dataset.loading !== undefined) return;
      grid.dataset.loading = '';
      const drop = () => grid.closest('.page-aside__products')?.remove();
      fetch(grid.dataset.popularUrl)
        .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
        .then((html) => {
          const cards = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-popular-cards]');
          const items = cards ? [...cards.children].slice(0, grid.children.length) : [];
          if (!items.length) return drop();
          items.forEach((li) => li.removeAttribute('class'));
          grid.replaceChildren(...items);
          grid.removeAttribute('aria-busy');
        })
        .catch(drop);
    }
  }

  if (!customElements.get('aura-page-aside')) customElements.define('aura-page-aside', AuraPageAside);
})();
